// extracted by mini-css-extract-plugin
module.exports = {"modal":"TweakControlVariant_modal__2qw4i"};